import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrderService {
    private apiUrl = environment.dashboard.url + environment.dashboard.path;

    constructor(private http: HttpClient) { }

    createPurchaseOrder(data: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}local-supplier-purchase-order`, data);
    }

    getPurchaseOrders(params: any, entityId: string): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}purchase-order`, {
            params,
            headers: { 'x-entity-ids': entityId }
        });
    }
}
